export const FAVORITE_WRITE_BATCH_SIZE = 20;

export function chunks(values, size = FAVORITE_WRITE_BATCH_SIZE) {
  const result = [];
  for (let offset = 0; offset < values.length; offset += size) {
    result.push(values.slice(offset, offset + size));
  }
  return result;
}

export function favoriteAdditions(rows, existingIds, cardKey, savedAt) {
  const known = new Set(existingIds || []);
  const additions = [];

  for (const row of Array.isArray(rows) ? rows : []) {
    if (!row) continue;
    const id = cardKey(row);
    if (!id || known.has(id)) continue;
    known.add(id);
    additions.push({
      id,
      saved: { ...row, __pwgCardKey: id, __pwgSavedAt: savedAt },
    });
  }
  return additions;
}

export function favoriteRemovals(rows, existingIds, cardKey) {
  const known = new Set(existingIds || []);
  const removals = [];

  for (const row of Array.isArray(rows) ? rows : []) {
    if (!row) continue;
    const id = cardKey(row);
    if (!id || !known.has(id)) continue;
    known.delete(id);
    removals.push(id);
  }
  return removals;
}
